import type { ReactElement } from 'react'
import { AppShell } from '../components/AppShell.js'
import { Button } from '../components/ui/button.js'
import { Icon } from '../components/installer/icons.js'
import { addDays, formatClosedStamp, formatMonDayYear } from '../lib/dates.js'
import { useDemoStore } from '../state/store.js'
import { useStep } from '../state/useStep.js'

export const SummaryScreen = (): ReactElement => {
  const { dispatch } = useDemoStore()
  const { goto } = useStep()

  const footer = (
    <Button
      size="xl"
      onClick={() => {
        dispatch({ type: 'SEAL' })
        goto('job-closed')
      }}
    >
      <Icon.CheckCircle /> Close Job
    </Button>
  )

  return (
    <AppShell
      title="Job summary"
      showBack
      onBack={() => goto('proof-bundle')}
      progress={1}
      footer={footer}
    >
      <div className="installer-surface page fade-in">

        {/* Seal banner */}
        <div className="summary-lock">
          <div className="lock-icon">
            <Icon.Lock />
          </div>
          <div>
            <span className="summary-chip">{formatClosedStamp(new Date())}</span>
            <div className="summary-title-sm">Seals the proof bundle</div>
            <div className="summary-sub">
              Closing this job seals the water-proof record, departure signal, and exception notes
              for the final handoff.
            </div>
          </div>
        </div>

        {/* Water closeout overview */}
        <div className="section-label">WATER CLOSEOUT OVERVIEW</div>
        <div className="closeout-cards">
          <div className="closeout-card success">
            <div className="icon">
              <Icon.CheckCircle />
            </div>
            <div>
              <div className="closeout-label">DEPARTURE SIGNAL</div>
              <div className="closeout-body">Water connection cleared after dry proof</div>
            </div>
          </div>
          <div className="closeout-card success">
            <div className="icon">
              <Icon.Camera />
            </div>
            <div>
              <div className="closeout-label">PROOF BUNDLE</div>
              <div className="closeout-body">5 required proof photos</div>
            </div>
          </div>
        </div>

        {/* Water-history saved */}
        <div className="section-label">WATER-HISTORY SAVED</div>
        <div className="conf-card">
          <div className="history-date">{formatMonDayYear(addDays(new Date(), -158))}</div>
          <div className="history-title">Prior dishwasher water-line check</div>
          <div className="history-body">
            Install history shows a dry cabinet floor, standard quarter-turn shutoff, and no
            recorded seepage after departure on the prior visit.
          </div>
        </div>
        <div className="conf-card">
          <div className="history-date">{formatMonDayYear(addDays(new Date(), -288))}</div>
          <div className="history-title">Under-sink baseline saved</div>
          <div className="history-body">
            Right-side electrical access and a similar hose path were documented before, which helps
            separate pre-existing conditions from new leak claims.
          </div>
        </div>

      </div>
    </AppShell>
  )
}
